export default "/_next/static/7fc0ad3f0d1e35372f00e388c94904cf.jpg";